import { render } from "./Modal.vue?vue&type=template&id=0e981d6a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=0e981d6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e981d6a"

export default script